import { TherapeuticDomainTranslationDto } from "../dto/therapeutic-domains/therapeutic-domain-translations.dto";
import { TherapeuticDomainTranslation } from "../models/therapeutic-domain.model";

export class TherapeuticDomainTranslationMapper {
  public static toModel(dto: TherapeuticDomainTranslationDto): TherapeuticDomainTranslation {
    return {
      languageId: dto.language_id,
      name: dto.name
    }
  }

  public static toDto(dto: TherapeuticDomainTranslation): TherapeuticDomainTranslationDto {
    return {
      language_id: dto.languageId,
      name: dto.name
    }
  }
}